require("!!/app/SPA/node_modules/script-loader/addScript.js")(require("!!/app/SPA/node_modules/raw-loader/index.js!/app/SPA/node_modules/perfect-scrollbar/dist/perfect-scrollbar.min.js"))


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/script-loader!/app/SPA/~/perfect-scrollbar/dist/perfect-scrollbar.min.js
// module id = ../../../../script-loader/index.js!../../../../perfect-scrollbar/dist/perfect-scrollbar.min.js
// module chunks = 3